import React from 'react';
import { Link } from 'react-router-dom';
import Blogimg01 from '../../../assets/images/blog/blog-image-five-1.jpg';
import Blogimg02 from '../../../assets/images/blog/blog-three-calendar.svg';
import Blogimg03 from '../../../assets/images/blog/blog-image-five-2.jpg';


const blogs = [
    {
        id: 1,
        image: Blogimg01,
        date: "18 November 2024",
        comments: "25 Comments",
        title: "Understanding behavioral biases and making to the rational way",
    },

    {
        id: 2,
        image: Blogimg03,
        date: "18 November 2024",
        comments: "25 Comments",
        title: "How to create your purpose-filled career comfortably",
    },
]

const Blog = () => {
    return (
        <>
            <div className="blog-section-five">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="heading-box">
                                <span
                                    className="sub-title-two animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Latest News
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Explore our stories &amp; insights
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-30">
                        {blogs.map((blog) => (
                            <div key={blog.id} className="col-lg-6">
                                <div
                                    className="blog-box-five animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <div className="blog-image-five">
                                        <img
                                            src={blog.image}
                                            alt="blog-image"
                                        />
                                    </div>
                                    <div className="blog-details-five">
                                        <ul className="blog-meta-three">
                                            <li>
                                                <img
                                                    src={Blogimg02}
                                                    alt="icon"
                                                />
                                                <Link to="/BlogDetails">{blog.date}</Link>
                                            </li>
                                            <li>
                                                <img
                                                    src="assets/images/blog/blog-three-comment.svg"
                                                    alt="icon"
                                                />
                                                <Link to="/BlogDetails">{blog.comments} </Link>
                                            </li>
                                        </ul>
                                        <h4>
                                            <Link to="/BlogDetails">
                                                {blog.title}
                                            </Link>
                                        </h4>
                                        <Link to="/BlogDetails" className="btn btn-light btn-theme">
                                            Read More <span>+</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Blog;
